<div class="item-container">
    <div class="item-header ">
        <h6 class="text-center mb-0">Select Object</h6>
        <div class="edit-icons cursor-pointer" (click)="onCancel()"><i class="material-icons">close</i></div>
    </div>
    <div class="main-box pt-3">
        <div class="content-box d-flex flex-column align-items-center " *ngFor="let item of objectArr" (click)="onAddObject(item.type)">
            <div class="content-img"><img [src]="item.img" class="img-fluid" alt="" ></div>
            <div class="content-txt">{{item.name}}</div>
        </div>
    </div>
</div>